import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=3b196a62&scoped=true&"
import script from "./ContactWidget.vue?vue&type=script&lang=js&"
export * from "./ContactWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContactWidget.vue?vue&type=style&index=0&id=3b196a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b196a62",
  null
  
)

export default component.exports